/**
 * Custom hook to provide React Router compatibility
 */
import { useHistory, useLocation, useParams } from 'react-router-dom';

export { useHistory, useLocation, useParams };

// HOC for class components that need router props
export function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        const history = useHistory();
        const location = useLocation();
        const params = useParams();
        
        const match = {
            params,
            path: location.pathname,
            url: location.pathname,
            isExact: true,
        };
        
        return <Component {...props} history={history} location={location} match={match} />;
    }
    
    return ComponentWithRouterProp;
}

export default useHistory;
